import { Accordion, Button, Empty, Heading } from "#/atoms";
import { FC, memo } from "react";

import { OrderPackagesProps } from "./PackageList.interface";
import { OrderTemplate } from "@/types";
import { Package } from "#/organisms";
import { StyledOrderTemplates } from "./PackageList.styled";
import { templateGroups } from "@/helpers";
import { useApi } from "@/api";

const PackageList: FC<OrderPackagesProps> = ({
  actionText,
  headerText,
  loadingOrderTemplates,
  onHeaderClick,
  onSelectOrderTemplate,
  orderTemplates,
  showHeader,
  useSimpleSelect = false
}) => {
  const accordionState = 'open';

  const { orderTemplate } = useApi();

  const groups = templateGroups;

  const handleActivate = (id: number, customerId: string | null) => {
    
    const templ = orderTemplates.find(o => o.id === id);
   
    if (templ)
      templ.dea = false;

    return orderTemplate.activateItem(id, customerId);
  }

  const handleClone = (id: number) => {
    return orderTemplate.cloneItem(id);
  }

  const handleDeactivate = (id: number) => {
    
    const templ = orderTemplates.find(o => o.id === id);
   
    if (templ)
      templ.dea = true;

    return orderTemplate.deactivateItem(id);
  }

  const handleDelete = (id: number) => {
    return orderTemplate.deleteItem(id);
  }

  const handleSet = (orderTemplateInput: OrderTemplate) => {
    return orderTemplate.set(orderTemplateInput);
  }

  const getOrderTemplates = () => {
    if (loadingOrderTemplates) {
      return 'Loading...'
    }

    if (orderTemplates.length > 0) {
      let ot = orderTemplates;

      const data = groups.map((group) => {
        const orderTemplatesGrouped = ot.filter((item) => group.groupMatchRegExp.test(item.description));
        ot = ot.filter((item) => !group.groupMatchRegExp.test(item.description));
        
        if (orderTemplatesGrouped.length === 0) {
          return (<></>);
        }

        return (
          <Package
            groupName={group.groupName}
            icons={[]}
            id={group.groupName}
            key={group.groupName}
            onClick={onSelectOrderTemplate}
            onActivate={handleActivate}
            onClone={handleClone}
            onDeactivate={handleDeactivate}
            onDelete={handleDelete}
            onSet={handleSet}
            orderTemplates={orderTemplatesGrouped}
            useSimpleSelect={useSimpleSelect}
          />
        );
      });

      const other = data.pop();
      
      if (other) {
        data.unshift(other);
      }

      return data;
    }

    return <Empty>No packages have been added yet.</Empty>;
  }

  return (
    <StyledOrderTemplates>
     { showHeader ?  <Accordion
          disableToggle={true}
          bodyDirection="row"
          header={<Heading scale={"h2"}>{headerText}</Heading>}
          state={accordionState}
          showArrow={false}
          >
            <div style={{textAlign:"right"}}>
              <Button onClick={onHeaderClick}>{actionText}</Button>
            </div>
        {getOrderTemplates()}
      </Accordion> : getOrderTemplates() }
    </StyledOrderTemplates>
  );
}

export default memo(PackageList);
